import * as React from 'react';

interface PrintWhiteHintProps {
    printWhite: boolean | null;
}

/**
 * Informational hint shown next to the Blending Mode selector and Color Profile picker.
 * Indicates whether DIS expects a white underbase for the product's currently selected
 * size and color (white underbase → Normal, no white underbase → Multiply).
 * Advisory only — does not alter user selection. Hidden when no verdict is returned.
 */
export default function PrintWhiteHint({ printWhite }: PrintWhiteHintProps) {
    if (printWhite === null) {
        return null;
    }

    return (
        <div className='advanced_print-white-hint'>
            {printWhite ? (
                <>
                    White underbase: <strong>Normal</strong>
                </>
            ) : (
                <>
                    No white underbase: <strong>Multiply</strong>
                </>
            )}
        </div>
    );
}
